import { setDefaultOptions } from 'date-fns';
import { fr } from 'date-fns/locale';
import posthog from 'posthog-js';
import { browser } from '$app/env';
import type { LayoutLoad } from './$types';
import { PUBLIC_POSTHOG_KEY } from '$app/env/public';
//Config for date-fns
setDefaultOptions({
	weekStartsOn: 1,
	locale: fr
});

export const load: LayoutLoad = async ({ data }) => {
	if (browser) {
		posthog.init(PUBLIC_POSTHOG_KEY, {
			api_host: 'https://eu.i.posthog.com',
			capture_pageview: false,
			capture_pageleave: false,
			autocapture: {
				dom_event_allowlist: ['click'],
				css_selector_allowlist: ['[data-posthog-id]']
			},
			loaded: function (posthog) {
				const consentCookie = document.cookie.split('; ').find((c) => c.startsWith('cc_cookie='));
				const hasAnalyticsConsent =
					consentCookie &&
					JSON.parse(decodeURIComponent(consentCookie.split('=')[1])).categories?.includes(
						'analytics'
					);

				if (!hasAnalyticsConsent) {
					posthog.opt_out_capturing();
				} else {
					posthog.opt_in_capturing();
				}
			}
		});
	}
	return { ...data };
};
